module.exports = __webpack_public_path__ + "img/skull_bj.cece789e.png";